import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; 
import './fonts/display.css';
import './index.css';
import App from './App.js';
import "react-datepicker/dist/react-datepicker.css";
import { TranslationProvider } from './translations'; // <- dodaj import
import { nalozZapisanyMotyw } from './utils/theme';
import { warmDisplayFont } from './fonts/warmDisplayFont';

// Motyw nakladamy PRZED renderem. Wczesniej nie robil tego nikt przy starcie: App.js mial
// komplet funkcji, ale zadna nie byla wolana, a Ustawienia nakladaly motyw dopiero przy
// wejsciu na swoja strone. Stad „po odswiezeniu znowu jasny, a w ustawieniach nagle ciemny".
nalozZapisanyMotyw();

// Kroj naglowkow zaczyna sie pobierac teraz, a nie dopiero gdy pierwszy tytul stanie na
// ekranie; inaczej tytul rysuje sie czcionka systemowa i podmienia na oczach uzytkownika.
warmDisplayFont();


/**
 * Service worker tylko w wersji produkcyjnej (FAZA A). W trybie deweloperskim przechwytywanie
 * zadan kloci sie z odswiezaniem na zywo i debugowanie zaczyna klamac. Rejestracja idzie po
 * `load`, zeby nie konkurowala o lacze z pierwszym renderem, a jej blad jest celowo tylko
 * logowany: aplikacja bez trybu offline dziala normalnie, wiec nie ma czego przerywac.
 */
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('Nie udalo sie zarejestrowac service workera:', e);
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TranslationProvider>
      <BrowserRouter> {/* <-- Wrap App with this */}
        <App />
      </BrowserRouter>
    </TranslationProvider>
  </React.StrictMode>
);


